'use strict';

exports.__esModule = true;
exports.isSandbox = exports.isRule = exports.isPurpose = exports.isPerimeter = exports.isGoverness = exports.createSandbox = exports.createRule = exports.createPerimeter = exports.WrongRuleDefinition = exports.VERSION = exports.StrictGoverness = exports.Sandbox = exports.Rule = exports.RestrictedMethodError = exports.Purpose = exports.PubSub = exports.Perimeter = exports.NoSandboxError = exports.NoPurposeError = exports.NoGovernessError = exports.NoExposedMethodError = exports.MiddlewareGoverness = exports.Logger = exports.HeadGoverness = exports.GermanGoverness = exports.EasyGoverness = exports.ArgumentError = exports.AccessDenied = undefined;

var _Logger = require('./Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _Perimeter = require('./Perimeter');

var _Perimeter2 = _interopRequireDefault(_Perimeter);

var _Purpose = require('./Purpose');

var _Purpose2 = _interopRequireDefault(_Purpose);

var _Rule = require('./Rule');

var _Rule2 = _interopRequireDefault(_Rule);

var _Sandbox = require('./Sandbox');

var _Sandbox2 = _interopRequireDefault(_Sandbox);

var _VERSION = require('./VERSION');

var _VERSION2 = _interopRequireDefault(_VERSION);

var _createPerimeter = require('./createPerimeter');

var _createPerimeter2 = _interopRequireDefault(_createPerimeter);

var _createRule = require('./createRule');

var _createRule2 = _interopRequireDefault(_createRule);

var _createSandbox = require('./createSandbox');

var _createSandbox2 = _interopRequireDefault(_createSandbox);

var _utils = require('./utils');

var _governesses = require('./governesses');

var _errors = require('./errors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AccessDenied = _errors.AccessDenied;
exports.ArgumentError = _errors.ArgumentError;
exports.EasyGoverness = _governesses.EasyGoverness;
exports.GermanGoverness = _governesses.GermanGoverness;
exports.HeadGoverness = _governesses.HeadGoverness;
exports.Logger = _Logger2.default;
exports.MiddlewareGoverness = _governesses.MiddlewareGoverness;
exports.NoExposedMethodError = _errors.NoExposedMethodError;
exports.NoGovernessError = _errors.NoGovernessError;
exports.NoPurposeError = _errors.NoPurposeError;
exports.NoSandboxError = _errors.NoSandboxError;
exports.Perimeter = _Perimeter2.default;
exports.PubSub = _utils.PubSub;
exports.Purpose = _Purpose2.default;
exports.RestrictedMethodError = _errors.RestrictedMethodError;
exports.Rule = _Rule2.default;
exports.Sandbox = _Sandbox2.default;
exports.StrictGoverness = _governesses.StrictGoverness;
exports.VERSION = _VERSION2.default;
exports.WrongRuleDefinition = _errors.WrongRuleDefinition;
exports.createPerimeter = _createPerimeter2.default;
exports.createRule = _createRule2.default;
exports.createSandbox = _createSandbox2.default;
exports.isGoverness = _utils.isGoverness;
exports.isPerimeter = _utils.isPerimeter;
exports.isPurpose = _utils.isPurpose;
exports.isRule = _utils.isRule;
exports.isSandbox = _utils.isSandbox;


var Kindergarten = {
  AccessDenied: _errors.AccessDenied,
  ArgumentError: _errors.ArgumentError,
  EasyGoverness: _governesses.EasyGoverness,
  GermanGoverness: _governesses.GermanGoverness,
  HeadGoverness: _governesses.HeadGoverness,
  Logger: _Logger2.default,
  MiddlewareGoverness: _governesses.MiddlewareGoverness,
  NoExposedMethodError: _errors.NoExposedMethodError,
  NoGovernessError: _errors.NoGovernessError,
  NoPurposeError: _errors.NoPurposeError,
  NoSandboxError: _errors.NoSandboxError,
  Perimeter: _Perimeter2.default,
  PubSub: _utils.PubSub,
  Purpose: _Purpose2.default,
  RestrictedMethodError: _errors.RestrictedMethodError,
  Rule: _Rule2.default,
  Sandbox: _Sandbox2.default,
  StrictGoverness: _governesses.StrictGoverness,
  VERSION: _VERSION2.default,
  WrongRuleDefinition: _errors.WrongRuleDefinition,
  createPerimeter: _createPerimeter2.default,
  createRule: _createRule2.default,
  createSandbox: _createSandbox2.default,
  isGoverness: _utils.isGoverness,
  isPerimeter: _utils.isPerimeter,
  isPurpose: _utils.isPurpose,
  isRule: _utils.isRule,
  isSandbox: _utils.isSandbox
};

exports.default = Kindergarten;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/index.js
// module id = mCTS
// module chunks = 0